import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  // mode: 'history',
  routes: [
    {
      name: "home",
      path: "/",
      component: () => import("@/pages/home.vue"),
    },
    {
      name: "about",
      path: "/about",
      component: () => import("@/pages/about.vue"),
    },
    {
      name: "lessons",
      path: "/Lessons",
      component: () => import("@/pages/lessons.vue"),
    },
    {
      name: "plays",
      path: "/Plays",
      component: () => import("@/pages/plays.vue"),
    },
    {
      name: "trains",
      path: "/Trains",
      component: () => import("@/pages/trains.vue"),
    },
    {
      name: "awards",
      path: "/Awards",
      component: () => import("@/pages/awards/index.vue"),
    },
    {
      name: "reset-password",
      path: "/reset-password",
      component: () => import("@/pages/awards/reset-password.vue"),
    },
    {
      name: "upload-work",
      path: "/upload-work",
      component: () => import("@/pages/awards/upload-work.vue"),
    },
    {
      name: "admin",
      path: "/admin",
      component: () => import("@/pages/admin/admin.vue"),
    },
    {
      name: "newsDetail",
      path: "/news/:id",
      component: () => import("@/pages/admin/NewsDetail.vue"),
    },
    {
      name: "course",
      path: "/Course",
      component: () => import("@/pages/course/index.vue"),
      redirect: "/Course/l202401",
      children: [
        {
          name: "l202401",
          path: "/Course/l202401",
          component: () => import("@/pages/course/l202401.vue"), // 腾讯SSV数字支教计划启动
        },
        {
          name: "l202301",
          path: "/Course/l202301",
          component: () => import("@/pages/course/l202301.vue"), // 虎虎生威存钱罐
        },
        {
          name: "l202302",
          path: "/Course/l202302",
          component: () => import("@/pages/course/l202302.vue"), // 古建筑中的色彩
        },
        {
          name: "l202201",
          path: "/Course/l202201",
          component: () => import("@/pages/course/l202201.vue"), // 色光协奏曲
        },
        {
          name: "l202202",
          path: "/Course/l202202",
          component: () => import("@/pages/course/l202202.vue"), // 为校园赋彩
        },
        {
          name: "l202203",
          path: "/Course/l202203",
          component: () => import("@/pages/course/l202203.vue"), // 色彩与味觉
        },
        {
          name: "l202204",
          path: "/Course/l202204",
          component: () => import("@/pages/course/l202204.vue"), // 苗绣——你绣山川我绣你
        },
        {
          name: "l202205",
          path: "/Course/l202205",
          component: () => import("@/pages/course/l202205.vue"), // 皇袍一定是黄色的吗？
        },
        {
          name: "l202206",
          path: "/Course/l202206",
          component: () => import("@/pages/course/l202206.vue"), // 解读《山海经》中神兽的色彩
        },
        {
          name: "l202207",
          path: "/Course/l202207",
          component: () => import("@/pages/course/l202207.vue"), // 走进唐三彩的彩色世界
        },
        {
          name: "l202208",
          path: "/Course/l202208",
          component: () => import("@/pages/course/l202208.vue"), // 木兰如何“贴花黄”?
        },
        {
          name: "p202503211",
          path: "/Course/p202503211",
          component: () => import("@/pages/course/p202503211.vue"),
        },
        {
          name: "p202503212",
          path: "/Course/p202503212",
          component: () => import("@/pages/course/p202503212.vue"),
        },
        {
          name: "p202503213",
          path: "/Course/p202503213",
          component: () => import("@/pages/course/p202503213.vue"),
        },
        {
          name: "p202503214",
          path: "/Course/p202503214",
          component: () => import("@/pages/course/p202503214.vue"),
        },
        {
          name: "p202503215",
          path: "/Course/p202503215",
          component: () => import("@/pages/course/p202503215.vue"),
        },
        {
          name: "p20250422",
          path: "/Course/p20250422",
          component: () => import("@/pages/course/p20250422.vue"),
        },
        {
          name: "p20250526",
          path: "/Course/p20250526",
          component: () => import("@/pages/course/p20250526.vue"),
        },
        {
          name: "p202407",
          path: "/Course/p202407",
          component: () => import("@/pages/course/p202407.vue"),
        },
        {
          name: "p2024071",
          path: "/Course/p2024071",
          component: () => import("@/pages/course/p2024071.vue"), // 湖南图书馆湘图讲坛|《传色千秋——中国传统建筑色彩的保护与传承》
        },
        {
          name: "p202408",
          path: "/Course/p202408",
          component: () => import("@/pages/course/p202408.vue"), // 万物有灵——东茅街小学儿童艺术展作品展览
        },
        {
          name: "p2024081",
          path: "/Course/p2024081",
          component: () => import("@/pages/course/p2024081.vue"), // 万物有灵——东茅街小学儿童艺术展作品展览
        },
        {
          name: "p2024082",
          path: "/Course/p2024082",
          component: () => import("@/pages/course/p2024082.vue"), // 万物有灵——东茅街小学儿童艺术展作品展览
        },
        {
          name: "p2024083",
          path: "/Course/p2024083",
          component: () => import("@/pages/course/p2024083.vue"), // 万物有灵——东茅街小学儿童艺术展作品展览
        },
        {
          name: "p202409",
          path: "/Course/p202409",
          component: () => import("@/pages/course/p202409.vue"), // 万物有灵——东茅街小学儿童艺术展作品展览
        },
        {
          name: "p202410",
          path: "/Course/p202410",
          component: () => import("@/pages/course/p202410.vue"), // 青少年高校科学营-守护中国色
        },
        {
          name: "p2024101",
          path: "/Course/p2024101",
          component: () => import("@/pages/course/p2024101.vue"), // 罗丽名师工作室
        },
        {
          name: "p202301",
          path: "/Course/p202301",
          component: () => import("@/pages/course/p202301.vue"), // 遇见非遗 古法草木植物染
        },
        {
          name: "p202302",
          path: "/Course/p202302",
          component: () => import("@/pages/course/p202302.vue"), // 国际色彩协会(AIC)大会
        },
        {
          name: "p202201",
          path: "/Course/p202201",
          component: () => import("@/pages/course/p202201.vue"), // 儿童色彩教育实践基地挂牌仪式
        },
        {
          name: "p202202",
          path: "/Course/p202202",
          component: () => import("@/pages/course/p202202.vue"), // 寻彩丰泉
        },
        {
          name: "p202203",
          path: "/Course/p202203",
          component: () => import("@/pages/course/p202203.vue"), // 焕彩东小
        },
        {
          name: "p202204",
          path: "/Course/p202204",
          component: () => import("@/pages/course/p202204.vue"), // 等等亭LOGO设计
        },
        {
          name: "p202205",
          path: "/Course/p202205",
          component: () => import("@/pages/course/p202205.vue"), // 古色新花
        },
        {
          name: "o202403",
          path: "/ongoing/t202301",
          component: () => import("@/pages/ongoing/o202403.vue"), // 伙伴招募
        },
        {
          name: "t202301",
          path: "/Course/t202301",
          component: () => import("@/pages/course/t202301.vue"), // AIC儿童色彩教育师资培训第一期
        },
        {
          name: "t202302",
          path: "/Course/t202302",
          component: () => import("@/pages/course/t202302.vue"), // AIC儿童色彩教育师资培训第二期
        },
        {
          name: "t202201",
          path: "/Course/t202201",
          component: () => import("@/pages/course/t202201.vue"), // 小学美术教师色彩素养培训第一期
        },
        {
          name: "t202202",
          path: "/Course/t202202",
          component: () => import("@/pages/course/t202202.vue"), // 小学美术教师色彩素养培训第二期
        },
        {
          name: "t202203",
          path: "/Course/t202203",
          component: () => import("@/pages/course/t202203.vue"), // 小学美术教师色彩素养培训第三期
        },
      ],
    },
  ],
});

export default router;
